module.exports = __webpack_public_path__ + "img/blog-two.8ac46db7.svg";